export default "https://cdn-static.gokick.com/assets/62cc856e78696df0fd8dcc0a94c6851d482ca838/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";